<div class="sgt-cliente-analise-mercado-revisao-form-info" *ngIf="revisao">
    <div class="row">
        <div class="form-group col-md-4 col-xl-2">
            <label class="col-form-label">Status</label>
            <br/>
            <sgt-cliente-analise-mercado-revisao-status-badge
                [props]="revisao"
                [styles]="{
                    fontSize: '10px'
                }">
            </sgt-cliente-analise-mercado-revisao-status-badge>
        </div>
        <div class="form-group col-md-4 col-xl-2">
            <label class="col-form-label">Revisão</label>
            <input type="text" class="form-control text-right" [value]="revisao.revisao" disabled="disabled" readonly="readonly">
        </div>
        <div class="form-group col-md-4 col-xl-2">
            <label class="col-form-label">Versão</label>
            <input type="text" class="form-control text-right" [value]="revisao.versao" disabled="disabled" readonly="readonly">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-md-4 col-xl-2">
            <label class="col-form-label">Ano</label>
            <input type="text" class="form-control text-right" [value]="revisao.ano" disabled="disabled" readonly="readonly">
        </div>
        <div class="form-group col-12 col-lg">
            <label class="col-form-label">Representante</label>
            <sgt-representante-form-input-disabled
                [codigoIntegracaoErp]="revisao.codigoIntegracaoErpRepresentante"
                [cnpjCpf]="revisao.cnpjCpfRepresentante"
                [nome]="revisao.nomeRepresentante"
                [nomeFantasia]="revisao.nomeFantasiaRepresentante">
            </sgt-representante-form-input-disabled>
        </div>
    </div>

    <!-- Abertura -->
    <div class="row">
        <div class="form-group col-md-4">
            <label class="col-form-label">Aberta Em</label>
            <input type="text" class="form-control text-center" value="{{revisao.dataAbertura | date:'dd/MM/yyyy'}} às {{revisao.dataAbertura | date:'HH:mm'}}" disabled="disabled" readonly="readonly">
        </div>
        <div class="form-group col">
            <label class="col-form-label">Aberta Por</label>
            <sgt-avatar
                [settings]="{
                    fullName: revisao.nomeUsuarioAbertura,
                    imageUrl: revisao.avatarURLUsuarioAbertura,
                    isShowLabelNameRight: true
                }">
            </sgt-avatar>
        </div>
    </div>

    <!-- Aprovação -->
    <ng-template [ngIf]="revisao.isAprovada">
        <div class="row">
            <div class="form-group col-md-4">
                <label class="col-form-label">Aprovada Em</label>
                <input type="text" class="form-control text-center" value="{{revisao.dataAprovacao | date:'dd/MM/yyyy'}} às {{revisao.dataAprovacao | date:'HH:mm'}}" disabled="disabled" readonly="readonly">
            </div>
            <div class="form-group col">
                <label class="col-form-label">Aprovada Por</label>
                <sgt-avatar
                  [settings]="{
                    fullName: revisao.nomeUsuarioAprovacao,
                    imageUrl: revisao.avatarURLUsuarioAprovacao,
                    isShowLabelNameRight: true
                  }">
                </sgt-avatar>
            </div>
        </div>
        <div class="row">
            <div class="form-group col">
                <label class="col-form-label">Justificativa Aprovação</label>
                <textarea class="form-control" rows="5" sgtAutosize disabled="disabled" readonly="readonly">{{revisao.justificativaAprovacao}}</textarea>
            </div>
        </div>
    </ng-template>
</div>
